export interface DiffLine {
  type: 'add' | 'del' | 'context' | 'hunk' | 'meta';
  content: string;
  oldLine?: number;
  newLine?: number;
}

const HUNK_RE = /^@@ -(\d+)(?:,(\d+))? \+(\d+)(?:,(\d+))? @@(.*)$/;

/** Parse a GitHub unified-diff patch into displayable lines with old/new line numbers. */
export function parsePatch(patch: string): DiffLine[] {
  const out: DiffLine[] = [];
  let oldLine = 0;
  let newLine = 0;
  for (const raw of patch.split('\n')) {
    const h = HUNK_RE.exec(raw);
    if (h) {
      oldLine = Number(h[1]);
      newLine = Number(h[3]);
      out.push({ type: 'hunk', content: raw });
      continue;
    }
    if (raw.startsWith('\\')) {
      out.push({ type: 'meta', content: raw.slice(2) });
      continue;
    }
    const m = raw[0];
    const content = raw.slice(1);
    if (m === '+') out.push({ type: 'add', content, newLine: newLine++ });
    else if (m === '-') out.push({ type: 'del', content, oldLine: oldLine++ });
    else out.push({ type: 'context', content, oldLine: oldLine++, newLine: newLine++ });
  }
  return out;
}

const LANGS: Record<string, string> = {
  ts: 'typescript',
  tsx: 'tsx',
  js: 'javascript',
  mjs: 'javascript',
  cjs: 'javascript',
  jsx: 'jsx',
  json: 'json',
  md: 'markdown',
  py: 'python',
  go: 'go',
  rs: 'rust',
  css: 'css',
  scss: 'css',
  sql: 'sql',
  yml: 'yaml',
  yaml: 'yaml',
  html: 'markup',
  xml: 'markup',
  svg: 'markup',
  sh: 'bash',
  c: 'c',
  h: 'c',
  cpp: 'cpp',
  java: 'java',
  kt: 'kotlin',
  swift: 'swift',
  rb: 'ruby',
  php: 'php',
  graphql: 'graphql',
};

export function languageFor(path: string): string {
  const ext = path.split('.').pop()?.toLowerCase() ?? '';
  return LANGS[ext] ?? 'clike';
}
